import { render } from "./menu-bar.vue?vue&type=template&id=2d9dfccd"
import script from "./menu-bar.vue?vue&type=script&lang=js"
export * from "./menu-bar.vue?vue&type=script&lang=js"

import "./menu-bar.vue?vue&type=style&index=0&id=2d9dfccd&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__